import React, { Component } from 'react';
import LocaleService from '../Services/LocaleService.js';

const defaultStore = {
	updater: () => {},
	adder: () => {},
	ready: false,
	locales: []
};

class LocalesProvider extends Component
{
	state = {
		locales: [],
		loaded: false
	};

	constructor (props) {
		super(props);
		
		this.service = new LocaleService(props.getApi());
	}

	load() {
		const that = this;

		this.service.fetch().then(function (locales) {
			that.setState({ locales: locales, loaded: true });
		});
	}

	update = (locale) => {
		const that = this;

		this.setState({
			loaded: false
		});

		this.setState({
			locales: that.state.locales.reduce(function (filtered, l) {
				if (l.props.id === locale) {
					filtered.push(locale);
				} else {
					filtered.push(l);
				}
				return filtered;
			}, []),
			loaded: true
		});
	}

	add = (locale) => {
		const that = this;

		this.setState({
			loaded: false
		});

		let locales = this.state.locales;
		locales.push(locale);

		this.setState({
			locales: locales,
			loaded: true
		});
	}

	componentWillReceiveProps(newProps) {
		if (newProps.auth.getUser() && !this.state.loaded) {
			this.load();
			this.setState({ loaded: true });
		}
	}

	render() {
		return (
			<LocalesContext.Provider 
				value={{
					updater: this.update,
					adder: this.add,
					ready: this.state.loaded,
					locales: this.state.locales
				}}
			>
				{this.props.children}
			</LocalesContext.Provider>
		);
	}
}

const LocalesContext = React.createContext(defaultStore);

export default LocalesProvider;
export const LocalesContextConsumer = LocalesContext.Consumer;
export function withValidLocales(Component) {
	return function WithValidLocalesComponent(props) {
		return (
			<LocalesContextConsumer>
			{
				context => 
					<Component 
						{...props} 
						localesContext={
							{
								updater: context.updater, 
								adder: context.adder,
								ready: context.ready,
								locales: context.locales.filter(function (l) {
									return !l.props.deleted;
								})
							}
						}
					/>
			}
			</LocalesContextConsumer>
		);
	}
}

export function withLocales(Component) {
	return function WithLocalesComponent(props) {
		return (
			<LocalesContextConsumer>
			{
				context => 
					<Component 
						{...props} 
						localesContext={
							{
								updater: context.updater, 
								adder: context.adder,
								ready: context.ready,
								locales: context.locales
							}
						}
					/>
			}
			</LocalesContextConsumer>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Providers/LocalesProvider.js